import { gql as parse } from '@apollo/client/core';
import { Image, Page } from '@react-pdf/renderer';
import React from 'react';
import {
  Barcode,
  Body,
  Box,
  Column,
  Debug,
  Flex,
  Label,
  Stencil,
  Title,
  Wine,
} from '../../pdf-design-system';
import Panel from './BarcelonaLogisticsPanel';
import box from './images/box.jpeg';
import pallet from './images/pallet.jpeg';
import stencil2 from './images/stencil-page2-72dpi.png';

export default function BarcelonaBrandsInfoSheetPage2({
  product: baseProduct,
  ...rest
}) {
  const product = afterQuery(baseProduct);
  return (
    <Page size="A4" style={{ paddingHorizontal: 18 }} {...rest}>
      {/* <Stencil src={stencil2} fixed /> */}

      <Flex
        style={{
          marginTop: 16,
          paddingHorizontal: 5,
          marginBottom: 22,
        }}
      >
        <Box>
          {/* This is the brand */}
          <Title>{product.producer?.name}</Title>
          {/* This is the product name. After reorganizing brands, this will be shorter */}
          <Title variant="smaller">{product.name}</Title>
          <Title variant="smallest">Logistic Sheet</Title>
        </Box>
        <Box></Box>
      </Flex>
      <Box style={{ height: 5, backgroundColor: 'black' }} />

      <Body
        style={{
          marginTop: 45,
        }}
      >
        <Column>
          <Panel height={152}>
            <Panel.Title>Bottle</Panel.Title>
            <Panel.Body>
              <Panel.LeftBody>
                <Wine.BottleImage height={90} trim />
              </Panel.LeftBody>
              <Panel.RightBody>
                <Wine.EanBottle
                  label="Ean Code Bottle"
                  variant="logistics"
                  orientation="horizontal"
                />
                <Wine.BottleSize
                  label="Volume"
                  variant="logistics"
                  orientation="horizontal"
                />

                <Wine.BottleHeight
                  label="Height"
                  variant="logistics"
                  orientation="horizontal"
                  unit="mm"
                />
                <Wine.BottleDiameter
                  label="Diam. / Width"
                  variant="logistics"
                  orientation="horizontal"
                  unit="mm"
                />
                <Wine.BottleWeightFull
                  label="Weight"
                  variant="logistics"
                  orientation="horizontal"
                />
              </Panel.RightBody>
            </Panel.Body>
          </Panel>
          <Panel height={173}>
            <Panel.Title>Case</Panel.Title>
            <Panel.Body>
              <Panel.LeftBody>
                <Image src={box} style={{ width: '52mm' }} />
              </Panel.LeftBody>
              <Panel.RightBody>
                <Wine.EanCase
                  label="EAN Code Case"
                  variant="logistics"
                  orientation="horizontal"
                />
                <Wine.BottlesPerCase
                  label="Bottles"
                  variant="logistics"
                  orientation="horizontal"
                />

                <Wine.CaseHeight
                  label="Height"
                  variant="logistics"
                  orientation="horizontal"
                  unit="mm"
                />
                <Wine.CaseLength
                  label="Length"
                  variant="logistics"
                  orientation="horizontal"
                  unit="mm"
                />
                <Wine.CaseWidth
                  label="Width"
                  variant="logistics"
                  orientation="horizontal"
                  unit="mm"
                />
                <Wine.CaseWeightFull
                  label="Weight"
                  variant="logistics"
                  orientation="horizontal"
                />
              </Panel.RightBody>
            </Panel.Body>
          </Panel>
          <Panel height={192}>
            <Panel.Title>Pallet</Panel.Title>
            <Panel.Body>
              <Panel.LeftBody>
                <Image src={pallet} style={{ width: '63mm' }} />
              </Panel.LeftBody>
              <Panel.RightBody>
                <Wine.Palletization
                  label="Palletisation"
                  variant="logistics"
                  orientation="horizontal"
                />
                <Wine.PalletType
                  label="Pallet type"
                  variant="logistics"
                  orientation="horizontal"
                />
              </Panel.RightBody>
            </Panel.Body>
          </Panel>

          <Panel height={147}>
            <Box
              style={{
                borderTop: '2px solid black',
                borderBottom: '2px solid black',
                paddingTop: 4,
                paddingBottom: 3,
                paddingLeft: 5,
              }}
            >
              <Flex>
                <Box style={{ width: '52.1%' }}>
                  <Label
                    variant="larger"
                    style={{
                      fontWeight: 600,
                    }}
                  >
                    Barcodes
                  </Label>
                  <Label>Bottle barcode</Label>
                </Box>
                <Flex style={{ alignItems: 'flex-end' }}>
                  <Label>Case barcode</Label>
                </Flex>
              </Flex>
            </Box>
            <Panel.Body>
              <Panel.LeftBody>
                <Barcode
                  value={product.bottleVariants[0]?.eanBottle}
                  height={80}
                />
              </Panel.LeftBody>
              <Panel.RightBody>
                <Barcode
                  value={product.packagingVariants[0]?.eanCase}
                  height={80}
                />
              </Panel.RightBody>
            </Panel.Body>
          </Panel>
        </Column>
      </Body>
      <Box style={{ height: 5, backgroundColor: 'black' }} />
      <Debug product={product} fixed />
    </Page>
  );
}

function afterQuery(product) {
  return {
    ...product,
  };
}

// We need to trick the IDE so we don't see errors for unknown fragments.
BarcelonaBrandsInfoSheetPage2.fragment = parse/* GraphQL */ `
  fragment BarcelonaBrandsInfoSheetPage2 on Product {
    productId

    # Bottle panel
    ...BottleImage
    ...BottleDiameter
    ...BottleHeight
    ...BottleSize
    ...BottleWeightFull
    ...EanBottle

    # Case panel
    ...BottlesPerCase
    ...CaseHeight
    ...CaseLength
    ...CaseWeightFull
    ...CaseWidth
    ...EanCase

    # Pallet panel
    ...CasesPerLayer
    ...PalletType
    ...Palletization

    # TODO
    # Add resolvers for pallet weights
  }
  ${Wine.BottleImage.fragment}

  ${Wine.BottleDiameter.fragment}
  ${Wine.BottleHeight.fragment}
  ${Wine.BottleSize.fragment}
  ${Wine.BottleWeightFull.fragment}
  ${Wine.EanBottle.fragment}

  ${Wine.BottlesPerCase.fragment}
  ${Wine.EanCase.fragment}
  ${Wine.CaseHeight.fragment}
  ${Wine.CaseLength.fragment}
  ${Wine.CaseWidth.fragment}
  ${Wine.CaseWeightFull.fragment}

  ${Wine.CasesPerLayer.fragment}
  ${Wine.PalletType.fragment}
  ${Wine.Palletization.fragment}
`;
